import { render } from "./RegistrationSuccess.vue?vue&type=template&id=5111b909&scoped=true&ts=true"
import script from "./RegistrationSuccess.vue?vue&type=script&lang=ts"
export * from "./RegistrationSuccess.vue?vue&type=script&lang=ts"

import "./RegistrationSuccess.vue?vue&type=style&index=0&id=5111b909&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5111b909"]])

export default __exports__